// Vendors
import * as PIXI from 'pixi.js'

export class Line extends PIXI.Graphics { 

    public pos: {x: number, y: number};
    public side: {
        top: number,
        right: number,
        left: number,
        bottom: number
    }

    constructor() {
        super();
    }
}